import { IFileUploadData, useMutation } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { VIDEO_IMAGE_SERVICE_API } from '../videoImageServiceClient';

/**
 * This is to track the file upload mutation keys in react query cache.
 */
const VIDEO_UPLOAD = 'video-upload-mutation-key';

interface IFileUploadMutationProps {
  /**
   * Callback to be called when the file is uploaded successfully
   */
  onErrorCallback: (err: IApiError) => void;
  onSuccessCallback: (fileUploadData: IFileUploadData) => void;
}
/**
 * This performs a post request for uploading a file.
 */
export const useImageVideoUploadMutation = ({
  onErrorCallback,
  onSuccessCallback,
}: IFileUploadMutationProps) => {
  const { data, isPending, isError, error, mutate, isSuccess, reset } =
    useMutation({
      mutationKey: [VIDEO_UPLOAD],
      networkMode: 'always', // Even make calls when offline
      mutationFn: VIDEO_IMAGE_SERVICE_API.videoUpload,
      onError: onErrorCallback,
      onSuccess: onSuccessCallback,
    });

  return {
    data,
    error,
    isError,
    isPending,
    isSuccess,
    mutate,
    reset,
  };
};
